import React, { useContext, useState, useEffect, Fragment } from "react";
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
import Usterka from "./Usterka/Usterka.js";
import Loader from "../Loader.js";
import MieszkaniecMojeDane from "./MieszkaniecMojeDane.js";
import MieszkaniecGlosowanie from "./Glosowanie/MieszkaniecGlosowanie.js";
import Zarzad from "./Zarzad.js";
import WspolnotaRaportZbiorowy from "../Wspolnoty/RaportZbiorowy/WspolnotaRaportZbiorowy.js";
import { AuthContext } from "../../Context/AuthProvider";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn, faFileInvoiceDollar, faCheckToSlot } from '@fortawesome/free-solid-svg-icons'
import { max_data_w_grupach } from "../../functions/grupy.js";
import { rozliczenieWodyWmAkt, rozliczenieWodyMAkt } from "../../functions/woda.js";

import { 
    fetchWspolnota,
    fetchMieszkaniec,
    fetchPrzelewyU, 
    fetchUlice, 
    fetchLokale,
    fetchGrupyU, 
    fetchPlanowaneZuzycieU,
    fetchStawkiJednorazoweIndU,
    fetchUdzialyKontaU,
    fetchStawki, 
    fetchStawkiInd,
    fetchUdzialyKontaAktU,
    fetchWspolnotaWazneNumery,
    fetchOdczytyU,
    fetchOdczytyWm,
    fetchRozliczenieWodyWmSaved,
    fetchRozliczenieWodyMSaved
} from '../../Redux/Actions.js'; 

// import { motion } from 'framer-motion';
// import { wstepy } from '../../functions/motions';

import { getTablicaCzynsze2, getTablicaPrzelewy2 } from "../../functions/tablice.js";
import { isArray, isObject } from "../../functions/utilities.js";

const Mieszkaniec = () => {

    const [userId, setUserId] = useState(undefined);
    const dispatch = useDispatch();   
    
    const [wspolnota, setWspolnota] = useState(undefined);
    const [tablicaCzynsze_u, setTablicaCzynsze_u] = useState(undefined);
    const [tablicaCzynsze_g, setTablicaCzynsze_g] = useState(undefined);
    const [tablicaPrzelewy_g, setTablicaPrzelewy_g] = useState(undefined);
    const [udzialyKonta_a, setUdzialyKonta_a] = useState(undefined);
    const [grupy_a, setGrupy_a] = useState(undefined);
    const [loaderOn, setLoaderOn] = useState(true);
    const [czyZarzad, setCzyZarzad] = useState(false);
    const [activeWindow, setActiveWindow] = useState("Moje dane");
    const [stawkiOst, setStawkiOst] = useState([]);
    const [zeroweGrupy, setZeroweGrupy] = useState([]);
    
    const wspolnotaArr = useSelector( state => state?.wspolnota?.data);
    const mieszkancy = useSelector(state => state?.mieszkaniec?.data);
    const przelewy_u = useSelector( state => state?.przelewyU?.data);
    const grupyU = useSelector( state => state?.grupyU?.data);
    const planowaneZuzycie = useSelector( state => state?.planowaneZuzycieU?.data);
    const lokale = useSelector( state => state?.lokale?.data);
    const ulice = useSelector( state => state?.ulice?.data);
    const wazneNumery = useSelector( state => state?.wspolnotaWazneNumery?.data);
    const odczytyU = useSelector( state => state?.odczytyU?.data);
    const odczytyWm = useSelector( state => state?.odczytyWm?.data);

    const stawki = useSelector( state => state?.stawki?.data);
    const stawkiInd = useSelector( state => state?.stawkiInd?.data );
    const stawkiJednorazowe = [];//useSelector( state => state?.stawkiJednorazowe?.data);
    const stawkiJednorazoweInd_u = useSelector( state => state?.stawkiJednorazoweIndU?.data);
        
    const udzialyKontaAktU = useSelector( state => state?.udzialyKontaAktU?.data);
    const udzialyKontaU = useSelector( state => state?.udzialyKontaU?.data);

    const [activeGroup, setActiveGroup] = useState({idw: 0, grupa_numer: 1});
    const [mieszkaniec, setMieszkaniec] = useState(undefined);

    const rozliczenieWodyMSaved = useSelector( state => state?.rozliczenieWodyMSaved?.data);
    const rozliczenieWodyWmSaved = useSelector( state => state?.rozliczenieWodyWmSaved?.data);
 
    const [rozliczenieWodyWmAktOpub, setRozliczenieWodyWmAktOpub] = useState([]);
    const [rozliczenieWodyMAktOpub, setRozliczenieWodyMAktOpub] = useState([]);
    const [odczytyWmOpub, setOdczytyWmOpub] = useState([]);

    useEffect( () => setRozliczenieWodyMAktOpub(rozliczenieWodyMAkt(rozliczenieWodyMSaved)), [rozliczenieWodyMSaved]);

    useEffect( () => { 
        
        const temp = rozliczenieWodyWmAkt(rozliczenieWodyWmSaved);

        const temp2 = temp?.flatMap( rozliczenieWm => {
            const mieszkaniec = rozliczenieWodyMAktOpub?.filter( m => m?.id_odczytu_wm == rozliczenieWm?.id_odczytu_wm );
            const czyMieszkaniec = mieszkaniec?.length;
            const m = rozliczenieWodyMSaved?.find( r => r?.id_odczytu_wm == rozliczenieWm?.id_odczytu_wm);
            const o = odczytyU?.filter( o => new Date(o.okres_poczatek) >= new Date(rozliczenieWm.okresPoczatek) && new Date(o.okres_koniec) <= new Date(rozliczenieWm.okresKoniec) );
            const procenty = [];
            procenty.push(m)
            if (czyMieszkaniec > 0) {
                return({
                    ...rozliczenieWm,
                    procenty,
                    odczytyWZakresie: o
                })
            } else return [];
        })
        setRozliczenieWodyWmAktOpub( temp2 );
    }, [rozliczenieWodyWmSaved, rozliczenieWodyMSaved, odczytyU]);

    useEffect(( ) => {
        const fetchUserId = async () => {
            try {
                if (userId === undefined) {
                    const response = await axios.get("api/mieszkaniec/id_user");
                    setUserId(response.data);
                }
            } catch (error) {
                console.error("There was an error!", error);
            }
        };
        fetchUserId();
    },[userId])

    useEffect( () => setOdczytyWmOpub( odczytyWm?.filter( o => o?.opublikowany == 1)), [odczytyWm]);

    useEffect( () => setWspolnota( wspolnotaArr && wspolnotaArr?.length > 0 ? wspolnotaArr[0] : [] ), [wspolnotaArr]);

    useEffect( () => {
        if (stawki && stawki?.length > 0)
            setStawkiOst(stawki[0])
    },[stawki]);

    useEffect( ( )=> {
        if (udzialyKontaAktU?.length > 0)  {
            setActiveGroup( { idw: udzialyKontaAktU[0].id_wspolnoty, grupa_numer: udzialyKontaAktU[0].grupa_numer } );
            setUdzialyKonta_a( udzialyKontaAktU[0] )
        }
    },[udzialyKontaAktU]);

    useEffect( () => setGrupy_a( grupyU?.filter( g => g.grupa_numer == activeGroup?.grupa_numer )) ,[grupyU, activeGroup]);

    useEffect( () => setMieszkaniec( mieszkancy?.length > 0 ? mieszkancy[0] : {} ), [mieszkancy]);

    useEffect( ()=> {
      dispatch(fetchWspolnota());
      dispatch(fetchMieszkaniec());
      dispatch(fetchPrzelewyU());
      dispatch(fetchGrupyU()); 
      dispatch(fetchLokale()); 
      dispatch(fetchUlice()); 
      dispatch(fetchPlanowaneZuzycieU());
      dispatch(fetchUdzialyKontaU());
      dispatch(fetchStawki()); 
      dispatch(fetchStawkiInd());
    //   dispatch(fetchStawkiJednorazowe());
      dispatch(fetchStawkiJednorazoweIndU());
      dispatch(fetchUdzialyKontaAktU());
      dispatch(fetchUdzialyKontaU());
      dispatch(fetchWspolnotaWazneNumery());
      dispatch(fetchOdczytyWm());
      dispatch(fetchOdczytyU());
      dispatch(fetchRozliczenieWodyMSaved());
      dispatch(fetchRozliczenieWodyWmSaved());
    },[dispatch]);

    useEffect( () => setCzyZarzad( mieszkaniec?.czy_zarzad == 1 ? true : false), [mieszkaniec]);
        
    useEffect( () => {
        const przelewyTemp = getTablicaPrzelewy2(wspolnotaArr, udzialyKontaAktU, przelewy_u)[0];//[0][0];
        if (przelewyTemp && przelewyTemp?.length > 0) {
            setTablicaPrzelewy_g( przelewyTemp[0]?.grupy?.length > 0 ? przelewyTemp[0]?.grupy?.find( g => g?.nr_grupyUdzial == activeGroup.grupa_numer)?.przelewy : []);
        }
        else 
            setTablicaPrzelewy_g([]);
    },[wspolnotaArr, udzialyKontaAktU, przelewy_u, activeGroup]);   

    useEffect( () => { 
        const tablicaTemp = getTablicaCzynsze2(wspolnotaArr, mieszkancy, grupyU, [],udzialyKontaU, udzialyKontaAktU, lokale, stawki, planowaneZuzycie, stawkiJednorazowe, stawkiInd, stawkiJednorazoweInd_u  /*, zaliczki */)[0];
        const tablicaTemp_g = tablicaTemp && tablicaTemp?.grupy;
        setTablicaCzynsze_u(tablicaTemp_g?.find( g => g?.id_user == userId));
    },[wspolnotaArr, mieszkancy, grupyU,udzialyKontaU, udzialyKontaAktU, lokale, stawki, planowaneZuzycie, stawkiInd, stawkiJednorazoweInd_u, userId])

    useEffect( () => {
        setTablicaCzynsze_g( tablicaCzynsze_u?.grupy_udzial_msc?.find( g => g?.grupa_numer == activeGroup.grupa_numer )  );
    },[tablicaCzynsze_u, activeGroup]);

    const handleMojeDane = () => setActiveWindow("Moje dane");
    const handleRozliczenie = () => setActiveWindow("Saldo wspólnoty");
    const handleRaportZbiorczy = () => setActiveWindow("Raport zbiorczy");
    const handleUsterka = () => setActiveWindow("Usterka");
    const handleGlosowanie = () => setActiveWindow("Głosowanie");

    const window = () => {
        switch(activeWindow) {
            case "Usterka": 
                return <Usterka
                    mieszkaniec={mieszkaniec}
                    wspolnota={wspolnota}
                />
            case "Moje dane":
                return <MieszkaniecMojeDane
                    wspolnota={wspolnota}
                    mieszkaniec={mieszkaniec}
                    ulice={ulice}
                    lokale={lokale}
                    grupyU={grupyU}
                    tablicaCzynsze_g={tablicaCzynsze_g}
                    tablicaPrzelewy_g={tablicaPrzelewy_g}
                    stawkiOst={stawkiOst}
                    stawkiJednorazowe_w={stawkiJednorazowe}
                    stawkiJednorazoweInd_u={stawkiJednorazoweInd_u}
                    grupy_a={grupy_a}
                    udzialyKonta_a={udzialyKonta_a}
                    setUdzialyKonta_a={setUdzialyKonta_a}
                    activeGroup={activeGroup}
                    setActiveGroup={setActiveGroup}
                    udzialyKontaAktU={udzialyKontaAktU}
                    zeroweGrupy={zeroweGrupy}
                    wazneNumery={wazneNumery}
                    rozliczenieWodyWmAktOpub={rozliczenieWodyWmAktOpub}
                    odczytyU={odczytyU}
                    odczytyWmOpub={odczytyWmOpub}
                />
            case "Saldo wspólnoty":
                return <Zarzad />
            case "Raport zbiorczy":
                return <WspolnotaRaportZbiorowy 
                    />
            case "Głosowanie":
                return <MieszkaniecGlosowanie
                    wspolnota={wspolnota}
                    mieszkaniec={mieszkaniec}
                />
        }
    }

    useEffect( () => { 
        if ( isObject(tablicaCzynsze_u) && isArray(tablicaPrzelewy_g) && lokale && ulice )
            setLoaderOn(false)
    },[ tablicaCzynsze_u, tablicaPrzelewy_g, lokale, ulice]);

    useEffect( () => {
        const temp = [];
        udzialyKontaAktU?.forEach( udzial => {
            const grupyTemp = grupyU?.filter( grupa => grupa?.grupa_numer == udzial.grupa_numer);
            const max = max_data_w_grupach(grupyTemp);

            if (max !== null && new Date(udzial.data_od) - max === 0)   
                temp.push(udzial)        
        })
        setZeroweGrupy(temp);
    }, [grupyU, udzialyKontaAktU]);

    console.log(rozliczenieWodyWmAktOpub)
    console.log(rozliczenieWodyMAktOpub)

    return ( 
        <div className="mieszkaniec">
            <Loader
                stan={loaderOn}
            />
            <div className="buttons">
                <button onClick={handleMojeDane}>
                    <FontAwesomeIcon icon={faFileInvoiceDollar} />
                    {`  `}
                    Moje dane
                </button>
                {
                    czyZarzad ? (
                        <Fragment>
                            <button className="raport" onClick={handleRozliczenie}>Saldo Wspólnoty</button>
                            <button className="raport" onClick={handleRaportZbiorczy}>Raport zbiorczy</button>
                        </Fragment>
                    ) : <Fragment></Fragment>
                }
                <button onClick={handleUsterka}>
                    <FontAwesomeIcon icon={faBullhorn} />
                    {`  `}
                    Zgłoś usterkę
                </button>
                <button onClick={handleGlosowanie}>
                    <FontAwesomeIcon icon={faCheckToSlot} />
                    {`  `}
                    Głosowanie
                </button>
            </div>
            { window() }
        </div>
    )
}

export default Mieszkaniec;